// import styled from "styled-components"
// import PageTopTitle from "../../components/shared/PageTopTitle"
// import { useEffect } from "react"
// import { useDispatch, useSelector } from "react-redux"
// import { createAnasayfaDuyuru, deleteAnasayfaDuyuru, getAnaSayfaBaslik, getAnasayfaDuyuruMessageItemData, getAnasayfaDuyurular, updateAnasayfaBaslik, updateAnasayfaDuyuru } from "../../features/admin/adminSlice"
// import { useState } from "react"
// import Button from "../../components/shared/button/Btn"
// import SmallSpinner from "../../components/shared/spinners/SmallSpinner"
// import SingleInput from "../../components/shared/SingleInput"
// import SingleTextarea from "../../components/shared/SingleTextarea"
// import { showModal } from "../../features/modal/modalSlice"

// const Container = styled.div`
//     width: 100%;

// .wrapper{
//   display: flex;
//   flex-direction: column;
//   align-items: center;

//   .content{
//     display: flex;
//     flex-direction: column;
//     gap: 40px;
//     width: 100%;
//     padding: 30px;

//     .content-item{
//       width: 100%;
//       border-radius: 10px;
//       background-color: ${({ theme }) => theme.secondaryBgColor};
//       padding: 20px;

//       h2{
//             text-align: start;
//             font-size: 18px;
//             padding-bottom: 8px;
//             font-weight: var(--font-weight-lg);
//             color: ${({ theme }) => theme.mainTextColor};

//             span{
//               font-size: 14px;
//             }
//       }

//       .group{
//         display: flex;
//         gap: 30px;
//       }

//       .duyuru-container{
//         display: flex;
//         flex-direction: column;
//         gap: 20px;

//         .duyuru-item{
//           display: flex;
//           align-items: center;

//           .duyuru-item-text{
//             width: calc(100% - 300px);
//             padding: 25px 15px;
//             min-height: 120px;
//             border-radius: 10px;
//             background-color: ${({theme})=> theme.mainBgColor};
//             font-size: 16px;
//             font-weight: var(--font-weight-md);
//             font-size: 16px;
//             color: ${({ theme }) => theme.mainTextColor};
//             font-weight: var(--font-weight-md);
//             line-height: 26px;
//           }

//           .btn-group{
//             padding: 10px;
//             display: flex;
//             justify-content: flex-end;
//             gap: 20px;
//             width: 300px;
//           }

//         }
//       }
//     }
//   }
// }
// `

// const YuklerListBaslikVeAciklamaEkle = () => {
//   const {userRole}  = useSelector((state)=> state.auth)

//   //! burada anasayfaBaslik da bir object var
//   const {anasayfaDuyurular, anasayfaBaslik} = useSelector(state => state.admin)
//   const [processedDuyuruMessage, setProcessedDuyuruMessage] = useState(null)
//   const [processedDuyuruMessageId, setProcessedDuyuruMessageId] = useState(null)

//   const allowedRoles = ["admin"]
//   const dispatch = useDispatch()
  
// const [baslik, setBaslik] = useState("")
// const [duyuruMessage, setDuyuruMessage] = useState("")

// useEffect(()=> {
//   if(anasayfaBaslik){
//     setBaslik(anasayfaBaslik.baslik)
//   }
// },[anasayfaBaslik])



//   useEffect(()=> {
//     dispatch(getAnasayfaDuyurular())
//     dispatch(getAnaSayfaBaslik())
//   },[])

//   const handleBaslikSubmit = () => {
//     if(baslik){
//       dispatch(updateAnasayfaBaslik({id: anasayfaBaslik.id, baslik}))
//       setBaslik("")
//     }
//   }

//   const handleMessageSubmit = () => {
//     if(duyuruMessage){
//       dispatch(createAnasayfaDuyuru({anasayfaDuyuruMetni: duyuruMessage}))
//       setDuyuruMessage("")
//     }
//   }

//   const handleProcessDuyuruMessage = (item) => {
//     setProcessedDuyuruMessageId(item.id)
//     setProcessedDuyuruMessage(item.anasayfaDuyuruMetni)
//     // console.log(item);
//   }
//   // console.log(processedDuyuruMessage);

//   const handleUpdateDuyuruMessage = () => {
//     if(processedDuyuruMessageId && processedDuyuruMessage){
//       dispatch(updateAnasayfaDuyuru({id: processedDuyuruMessageId, anasayfaDuyuruMetni: processedDuyuruMessage}))
//       setProcessedDuyuruMessage(null)
//       setProcessedDuyuruMessageId(null)
//     }
//   }


//   if(!authorize(userRole, allowedRoles)){
//     return <div>Aradığınız sayfa bulunamadı.</div>
//   }

//   return (
//     <Container>
//     <div className="wrapper">
//       <PageTopTitle title={"Yük Listesi Başlık ve Açıklama"} position='sticky'/>
//       <div className="content">
//           <div className="content-item">
//             <h2>Duyuru Başlığı</h2>
//             <div className="group">
//                 <SingleInput  value={baslik} handleChange={setBaslik} width={"calc(100% - 300px)"}/>
//                 <Button color={"#E85546"} background={"#fff"} width="200px" radius={"10px"} padding="0 10px" handleClick={handleBaslikSubmit}>{false ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#9ded9a"}/>: "Kaydet & Güncelle"}</Button>
//             </div>
//           </div>
//           <div className="content-item">
//             <h2>Duyuru Mesajı <span>(Kalın punto için kelimenin başına * koyunuz)</span></h2>
//             <div className="group">
//                 <SingleTextarea  value={duyuruMessage} handleChange={setDuyuruMessage} width={"calc(100% - 300px)"}/>
//                 <Button color={"#E85546"} background={"#fff"} width="200px" radius={"10px"} padding="0 10px" handleClick={handleMessageSubmit}>{false ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#9ded9a"}/>: "Duyuru Mesajı Ekle"}</Button>
//             </div>
//           </div>

//           <div className="content-item">
//             <h2>Duyuru Mesajları</h2>
//             <div className="duyuru-container">
//             {
//               anasayfaDuyurular?.map((item)=> (
//                 <div className="duyuru-item" key={item.id}>
//                   {
//                       processedDuyuruMessageId === item.id ?
//                       <SingleTextarea  value={processedDuyuruMessage} handleChange={setProcessedDuyuruMessage} width={"calc(100% - 300px)"}/>:
//                       <p className="duyuru-item-text">{item.anasayfaDuyuruMetni}</p>

//                   }
//                   <div className="btn-group">
//                     {
//                       processedDuyuruMessageId === item.id ?
//                     <>
//                       <Button color={"#E85546"} background={"#fff"} width="120px" radius={"10px"} padding="0 10px" handleClick={handleUpdateDuyuruMessage}>{false ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#9ded9a"}/>: "Kaydet"}</Button>
//                       <Button color={"#E85546"} background={"#fff"} width="120px" radius={"10px"} padding="0 10px" handleClick={() => {setProcessedDuyuruMessage(null); setProcessedDuyuruMessageId(null)}}>{false ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#9ded9a"}/>: "İptal"}</Button>
//                     </>
//                     :
//                     <>
//                       <Button color={"#E85546"} background={"#fff"} width="120px" radius={"10px"} padding="0 10px" handleClick={() => handleProcessDuyuruMessage(item)}>{false ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#9ded9a"}/>: "Güncelle"}</Button>
//                       <Button color={"#E85546"} background={"#fff"} width="120px" radius={"10px"} padding="0 10px" handleClick={() => {dispatch(getAnasayfaDuyuruMessageItemData(item)); dispatch(showModal("deleteAnasayfaDuyuruItem"))}}>{false ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#9ded9a"}/>: "Sil"}</Button>
//                     </>
//                     }
//                   </div>
//                 </div>
//               ))
//             }
//            </div>
//           </div>
//       </div>
//     </div>
//     </Container>
//   )
// }

// export default YuklerListBaslikVeAciklamaEkle



import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { createAnasayfaDuyuru, deleteAnasayfaDuyuru, getAnaSayfaBaslik, getAnasayfaDuyuruMessageItemData, getAnasayfaDuyurular, updateAnasayfaBaslik, updateAnasayfaDuyuru } from "../../features/admin/adminSlice"
import { useState } from "react"
import SmallSpinner from "../../components/shared/spinners/SmallSpinner"
import TopMenus from "../../components/shared/TopMenus"
import InputText from "../../components/shared/input/new/InputText"
import Btn from "../../components/shared/button/Btn"
import InputTextarea from "../../components/shared/input/new/InputTextarea"

const Container = styled.div`
    width: 100%;

    .wrapper{
      display: flex;
      flex-direction: column;
      align-items: center;

      .content{
        display: flex;
        flex-direction: column;
        gap: 40px;
        width: 100%;
        padding: 30px;

        .main-content{
          width: 100%;
          color: ${({theme}) => theme.mainTextColor};

          .duyuru-baslik-content{
            width: 400px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 25px;
          }

          .duyuru-message-content{
            width: 100%;
            display: flex;
            gap: 40px;

            .add-container{
              width: calc(40% - 20px);

              h3{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                padding-bottom: 10px;
              }
            }

            .past-container{
              width: calc(60% - 20px);
              display: flex;
              flex-direction: column;

              h3{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                padding-bottom: 10px;
              }

              .message-item{
                width: 100%;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                padding: 10px 0;
                border-radius: 10px;
                line-height: 1.4;
                /* border: 1px solid ${({theme}) => theme.mainTextColor}; */

                .message-item-btn-container{
                  display: flex;
                  gap: 20px;
                  padding-top: 10px;
                }

              }

            }


          }
        }

      }
    }
`

const menulist = [
  {
      id: 1,
      text: "Duyuru Başlığı"
  },
  {
      id: 2,
      text: "Duyuru Mesajları"
  },
]


const YuklerListBaslikVeAciklamaEkle = () => {

  const {anasayfaDuyurular, anasayfaBaslik} = useSelector(state => state.admin)

  const dispatch = useDispatch()

  const [activeMenuId, setActiveMenuId] = useState(1)

  const [duyuruBaslikText, setDuyuruBaslikText] = useState("")
  const [newDuyuruMessage, setNewDuyuruMessage] = useState("")

  const [updatedDuyuruMessageList, setUpdatedDuyuruMessageList ] = useState([])

  useEffect(() => {
    setUpdatedDuyuruMessageList(anasayfaDuyurular)
  },[anasayfaDuyurular])

  useEffect(() => {
    setDuyuruBaslikText(anasayfaBaslik?.baslik)
  },[anasayfaBaslik])

  const handleMessage = ({value, id}) => {
    const list = updatedDuyuruMessageList.map((item) => {
      if(item.id === id){
        return {...item, anasayfaDuyuruMetni: value}
      }
      else{
        return item
      }
    })

    setUpdatedDuyuruMessageList(list)
  }

  

  useEffect(()=> {
    dispatch(getAnasayfaDuyurular())
    dispatch(getAnaSayfaBaslik())
  },[])

  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"Yük Listesi Başlık ve Açıklama"} position='sticky'/>
        <div className="content">
          <TopMenus menuList={menulist} activeMenuId={activeMenuId} setActiveMenuId={setActiveMenuId} containerWidth="600px"/>
            <div className="main-content">
              {
                activeMenuId === 1 &&
                <div className="duyuru-baslik-content">
                    <InputText data={duyuruBaslikText} setData={(e) => setDuyuruBaslikText(e.target.value)} labelText="Duyuru Başlığı" inputWidth={"600px"}/>
                    <Btn bgColor="#E85546" color="#fff" width={"350px"} handleClick={() => dispatch(updateAnasayfaBaslik({baslik: duyuruBaslikText, id: null, href: null}))}>Güncelle</Btn>
                </div>
              }
              {
                activeMenuId === 2 &&
                <div className="duyuru-message-content">
                  <div className="add-container">
                    <h3>Yeni Duyuru Mesajı Ekle</h3>
                    <InputTextarea data={newDuyuruMessage} setData={(e) => setNewDuyuruMessage(e.target.value)} labelText={"Duyuru Mesajı (Kalın punto için kelimenin başına * koyunuz)"} inputWidth={"100%"}/>
                    <Btn bgColor="#E85546" color="#fff" width={"350px"} handleClick={() => dispatch(createAnasayfaDuyuru({anasayfaDuyuru: newDuyuruMessage, id: null, href: null}))}>Ekle</Btn>

                  </div>
                  <div className="past-container">
                    <h3>Mevcut Duyuru Mesajları</h3>
                    {
                      updatedDuyuruMessageList.map((item, i) => (
                        <div className={"message-item"} key={item.id}>
                              <InputTextarea data={item.anasayfaDuyuruMetni} setData={(e) => handleMessage({value: e.target.value, id: item.id})} labelText={"Duyuru Mesajı (Kalın punto için kelimenin başına * koyunuz)"} inputWidth={"100%"}/>
                              <div className="message-item-btn-container">
                                  <Btn bgColor={JSON.stringify(updatedDuyuruMessageList[i]) !== JSON.stringify(anasayfaDuyurular[i]) ? "#E85546" : "transparent"}  borderColor={JSON.stringify(updatedDuyuruMessageList[i]) === JSON.stringify(anasayfaDuyurular[i]) ? "#E85546" : "transparent"} color={JSON.stringify(updatedDuyuruMessageList[i]) !== JSON.stringify(anasayfaDuyurular[i]) ? "#fff" : "#E85546"} width={"200px"} cursor={JSON.stringify(updatedDuyuruMessageList[i]) !== JSON.stringify(anasayfaDuyurular[i]) ? "pointer" : "initial"} handleClick={() => JSON.stringify(updatedDuyuruMessageList[i]) !== JSON.stringify(anasayfaDuyurular[i]) && dispatch(updateAnasayfaDuyuru(item))}>{JSON.stringify(updatedDuyuruMessageList[i]) === JSON.stringify(anasayfaDuyurular[i]) ? "Güncel" :"Güncelle"}</Btn>
                                  <Btn bgColor="transparent" borderColor="#E85546" color="#E85546" width={"200px"} handleClick={() => dispatch(deleteAnasayfaDuyuru(item))}>Sil</Btn>
                              </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
              }
            </div>
        </div>
    </div>
    </Container>
  )
}

export default YuklerListBaslikVeAciklamaEkle